<script>
  import BaseChart  from './ChartBase';
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'DashboardServicesChart',

    extends: BaseChart,

    computed: { 
      ...mapGetters('dashboards', { dataset: 'byService' })
    },

    methods: {
      ...mapActions('dashboards', { load: 'loadByService' }),
    },

  }
</script>
